import { WebsitePageInterface } from 'src/editor/store/website-pages/website-pages-types'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

export const websitePageMock = (id = 1): WebsitePageInterface => ({
  name: 'test-page',
  locale: PageLocaleEnum.ENGLISH,
  website: {
    id,
    layoutPageId: 123,
    locales: [PageLocaleEnum.ENGLISH, PageLocaleEnum.FRENCH],
    style: {
      typography: {
        heading: {
          textColor: '',
          backgroundColor: '',
          fontFamily: '',
          fontWeight: '',
          fontSize: 0,
          lineHeight: 0,
          textAlign: 'left',
          letterSpacing: 0,
        },
        paragraph: {
          textColor: '',
          backgroundColor: '',
          fontFamily: '',
          fontWeight: '',
          fontSize: 0,
          lineHeight: 0,
          textAlign: 'left',
          letterSpacing: 0,
        },
      },
      buttonsAndLinks: {
        primary: {
          colors: {
            buttonText: '',
            buttonBackground: '',
            hoveredButtonBackground: '',
            pressedButtonBackground: '',
          },
          style: '',
          paddingY: 0,
          paddingX: 0,
          borderRadius: 0,
          borderType: '',
          borderStyle: '',
          borderWidth: 0,
          borderTopWidth: 0,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderBottomWidth: 0,
          typography: {
            fontFamily: '',
            fontWeight: '',
            fontSize: 0,
            lineHeight: 0,
            textAlign: 'left',
            letterSpacing: 0,
          },
        },
        secondary: undefined,
        links: undefined,
      },
      formFields: {
        colors: {
          formFieldText: '',
          formFieldBackground: '',
          formFieldBorder: '',
        },
        style: '',
        paddingY: 0,
        paddingX: 0,
        borderRadius: 0,
        borderType: '',
        borderStyle: '',
        borderWidth: 0,
        borderTopWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        typography: {
          fontFamily: '',
          fontWeight: '',
          fontSize: 0,
          lineHeight: 0,
          textAlign: 'left',
          letterSpacing: 0,
        },
      },
      layout: {
        contentWidth: 'xs',
        layoutGrid: {
          rowsCount: 0,
          horizontalGap: 0,
          verticalGap: 0,
        },
      },
    },
    theme: {
      isCommon: true,
      name: 'Theme 1',
      background: {
        pageBackgroundColor: '#DFF1FD',
        pageBackgroundPictureId: 316,
        sectionBackgroundColor: '#F2F2F3',
        containerBackgroundColor: '#F2F2F3',
        popupBackgroundColor: '#FFFFFF',
      },
      headerAndFooter: {
        headerTextColor: '#0C0D0D',
        headerBackgroundColor: '#D7D8DA',
        headerBackgroundPictureId: 694,
        footerTextColor: '#0C0D0D',
        footerBackgroundColor: '#D7D8DA',
        footerBackgroundPictureId: 486,
      },
      text: {
        headingTextColor: '#19191B',
        headingBackgroundColor: '',
        paragraphTextColor: '#7B7E85',
        paragraphBackgroundColor: '',
      },
      buttons: {
        primaryButtonTextColor: '#EFF8FE',
        primaryButtonBackgroundColor: '#00A0FF',
        primaryHoveredButtonBackgroundColor: '#0286CA',
        primaryPressedButtonBackgroundColor: '#0368A0',
        secondaryButtonTextColor: '#00A0FF',
        secondaryButtonBackgroundColor: '#DFF1FD',
        secondaryHoveredButtonBackgroundColor: '#DFF1FD',
        secondaryPressedButtonBackgroundColor: '#B9E5FC',
        ghostButtonTextColor: '#0C0D0D',
        ghostHoveredButtonBackgroundColor: '#D7D8DA',
        ghostPressedButtonBackgroundColor: '#CACBCE',
      },
      links: {
        linkTextColor: '#00A0FF',
        linkHoveredBackgroundColor: '#0286CA',
        linkPressedBackgroundColor: '#0368A0',
      },
      formFields: {
        formFieldBackgroundColor: '#FFFFFF',
        formFieldTextColor: '#19191B',
        formFieldBorderColor: '#D7D8DA',
      },
      miscellaneous: {
        dividersColor: '#D7D8DA',
      },
    },
  },
})
